import React from "react";
import ProfitReport from "./ProfitReport";

// Api/Reports/DatewiseProfitReport - see ProfitReport.jsx
const DateWiseProfit = () => <ProfitReport kind="date" />;

export default DateWiseProfit;
